import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_SALESPAYMENT,
  DELETE_SALESPAYMENT,
  UPDATE_SALESPAYMENT,
  ADD_NEW_SALESPAYMENT,
} from "./actionType";

import {
  getSalesPaymentSuccess,
  getSalesPaymentFail,
  deleteSalesPaymentSuccess,
  deleteSalesPaymentFail,
  updateSalesPaymentSuccess,
  updateSalesPaymentFail,
  addSalesPaymentSuccess,
  addSalesPaymentFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveSalesPaymentApi,
  getSalesPaymentApi,
  updateSalesPaymentApi,
  deleteSalesPaymentApi,
  addNewSalesPaymentApi
} from "../../helpers/backend_helper";

function* getSalesPayment({ payload: salesPayment }) {
  try {
    const response = yield call(getSalesPaymentApi, salesPayment);
    yield put(getSalesPaymentSuccess(GET_SALESPAYMENT, response.data));
  } catch (error) {
    yield put(getSalesPaymentFail(GET_SALESPAYMENT, error));
  }
}

function* onUpdateSalesPayment({ payload: salesPayment }) {
  try {
    if (salesPayment.setApprove) {
      const response = yield call(approveSalesPaymentApi, salesPayment);
      yield put(updateSalesPaymentSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateSalesPaymentApi, salesPayment);
      yield put(updateSalesPaymentSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateSalesPaymentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteSalesPayment({ payload: salesPayment }) {
  try {
    const response = yield call(deleteSalesPaymentApi, salesPayment);
    yield put(deleteSalesPaymentSuccess({ salesPayment, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteSalesPaymentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewSalesPayment({ payload: salesPayment }) {
  try {
    const response = yield call(addNewSalesPaymentApi, salesPayment);
    yield put(addSalesPaymentSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addSalesPaymentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetSalesPayment() {
  yield takeEvery(GET_SALESPAYMENT, getSalesPayment);
}

export function* watchUpdateSalesPayment() {
  yield takeEvery(UPDATE_SALESPAYMENT, onUpdateSalesPayment);
}

export function* watchDeleteSalesPayment() {
  yield takeEvery(DELETE_SALESPAYMENT, onDeleteSalesPayment);
}

export function* watchAddNewSalesPayment() {
  yield takeEvery(ADD_NEW_SALESPAYMENT, onAddNewSalesPayment);
}

function* salesPaymentSaga() {
  yield all([
    fork(watchGetSalesPayment),
    fork(watchDeleteSalesPayment),
    fork(watchUpdateSalesPayment),
    fork(watchAddNewSalesPayment)
  ]);
}

export default salesPaymentSaga;
